export default initData => {
    const {
        cleanedMemberAlias,
        facebookId,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberCountry,
        memberEmail,
        memberFirstName,
        memberId,
        memberHeroImage,
        memberLastName,
        paymentSettings = {}
    } = initData;
    return {
        cleanedMemberAlias,
        facebookId,
        geolocation: null,
        isLoggedIn,
        memberAlias,
        memberDetailedSellerRatingAverage,
        memberCountry,
        memberEmail,
        memberFirstName,
        memberId,
        memberHeroImage,
        memberLastName,
        paymentSettings
    };
};
